import { useSyncExternalStore } from 'react';

const subscribe = (onChange: () => void) => {
  document.addEventListener('visibilitychange', onChange);
  return () => {
    document.removeEventListener('visibilitychange', onChange);
  };
};

const getSnapshot = () => document.visibilityState === 'visible';

/** Видна ли вкладка: опрашивать сервер из скрытой вкладки незачем */
export const useDocumentVisibility = () => useSyncExternalStore(subscribe, getSnapshot, () => true);
